//This component will show  popup for filter
 
import { connect } from "react-redux";
import React from "react";
import { activateDatadic, activatePath,activateShowfilter } from "../redux";
import { Button, Modal, Typography } from "antd";

import {
  UserOutlined,PlayCircleTwoTone 
} from '@ant-design/icons';
const { Title } = Typography;

class PopmsgClass extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalVisible: true,
      setIsModalVisible: true,
    };

    this.handlefilter = this.handlefilter.bind(this);
  
  }

  handlefilter(){
    this.props.showModal();
    this.setState({
       
      isModalVisible: false,
    });

  
  }
  
  render() {
  
    
 

    const handleOk = () => {
      this.setState({
        setIsModalVisible: false,
        isModalVisible: false,
      });
    
    };

    const handleCancel = () => {
      this.setState({
        setIsModalVisible: false,
        isModalVisible: false,
      });
    };

    const showModal = () => {
      this.setState({
        setIsModalVisible: true,
        isModalVisible: true,
      });
    };
 
    const resultss = {
      float: "left",
      marginTop: "18px",
    };

    return (
      <div>
       

        <Modal
          title={<span style={{color:'#4287f5',fontSize:'18px'}}> Online stock screener</span>}
          width={800}
          okButtonProps={{ style: { display: 'none' } }}
          visible={this.state.isModalVisible}
          centered={true}
          onCancel={handleCancel}
          className="popmsg"
        ><p>
          Welcome to AAII’s online stock screener, where you can 
quickly identify stocks that match the criteria that are most important to you.</p>
<div style={{paddingLeft:'20px'}}>     <a href={'https://youtu.be/fdzFFDLy86k'}  target="_blank"><Button type="primary" shape="round" icon={<PlayCircleTwoTone  />}>
Learn to use the custom stock screener with this video.
    </Button></a> {'     '}<Button style={{marginLeft:'40px'}} onClick={this.handlefilter} type="primary" shape="round"  >Start filtering stocks</Button></div>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  datadic: state.datadic,
  apppath: state.apppath,
  showfilter: state.showfilter,
});

const mapDispatchToProps = {
  activateDatadic,activateShowfilter,
};

const Popmsg = connect(mapStateToProps, mapDispatchToProps)(PopmsgClass);

export default Popmsg;
